var exports = {
  "iE": "xa15a2ab7--4d330e--wrapper",
  "DD": "xa15a2ab7--4d330e--title",
  "o1": "xa15a2ab7--4d330e--actions",
  "Uo": "xa15a2ab7--4d330e--buttons",
};

module.exports = exports;
